import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { PROFILE_COPY } from '../../profile.copy';

const [BEFORE, AFTER] = PROFILE_COPY.ORDERS.UNVERIFIED.split('{ajustes}');

/**
 * Aviso de B44 en «Mis pedidos» (texto aprobado por Adrián el 30/09/2026): la cuenta `cliente` sin verificar no ve
 * pedidos. «Ajustes» enlaza a `/perfil/ajustes`, donde W3 pone «Reenviar correo de verificación».
 */
@Component({
  selector: 'app-profile-orders-unverified',
  imports: [RouterLink],
  template: `
    <p class="orders-unverified">
      {{ before }}<a class="orders-unverified__link" routerLink="/perfil/ajustes">{{ link }}</a>{{ after }}
    </p>
  `,
  styles: `
    .orders-unverified {
      margin: 0;
      padding: var(--space-4) var(--space-5);
      font-family: var(--font-family-body);
      font-size: var(--text-size-sm);
      color: var(--color-text-dark);
      background: color-mix(in srgb, var(--color-brand-primary) 10%, var(--color-surface-primary));
      border-left: 3px solid var(--color-brand-primary);
    }

    .orders-unverified__link {
      color: var(--color-brand-secondary);
      font-weight: var(--font-weight-body-medium);
      text-decoration: underline;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileOrdersUnverifiedComponent {
  protected readonly before = BEFORE;
  protected readonly after = AFTER;
  protected readonly link = PROFILE_COPY.ORDERS.UNVERIFIED_SETTINGS_LINK;
}
